"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

/**
 * Handles Swiper animations.
 */
var SwiperAnimation = /*#__PURE__*/function () {
  /**
   * Class constructor.
   *
   * @param {SwiperInfo} info Swiper info.
   * @param {Element} element Swiper element.
   */
  function SwiperAnimation(info, element) {
    _classCallCheck(this, SwiperAnimation);

    this.defaultTransitionTime = 500;
    this._info = info;
    this._transitionDuration = 0;
    this._easing = 'ease-out';
    this._element = element;
    this._wrapperElement = null;
    this._containerElement = null;
    this._transitions = [];
  }
  /**
   * Sets swiper postion.
   *
   * @param {number} position Position.
   */


  _createClass(SwiperAnimation, [{
    key: "setPosition",
    value: function setPosition(position) {
      var transform;

      if (this._info.useTranslate3d) {
        transform = this._info.vertical ? "translate3d(0, ".concat(position, "px, 0)") : "translate3d(".concat(this._info.rtl ? position * -1 : position, "px, 0, 0)");
      } else {
        transform = this._info.vertical ? "translate(0, ".concat(position, "px)") : "translate(".concat(this._info.rtl ? position * -1 : position, "px, 0)");
      }

      this._getContainerElement().style.transform = transform;
    }
    /**
     * Start dragging.
     */

  }, {
    key: "startDragging",
    value: function startDragging() {
      this.getWrapperElement().parentNode.classList.add('Swiper--dragging');
    }
    /**
     * End dragging.
     */

  }, {
    key: "endDragging",
    value: function endDragging() {
      this.getWrapperElement().parentNode.classList.remove('Swiper--dragging');
    }
    /**
     * Sets transition duration.
     *
     * @param {number} time Transition time.
     */

  }, {
    key: "setTransitionDuration",
    value: function setTransitionDuration(time) {
      var containerElement = this._getContainerElement();

      this._transitionDuration = time;

      if (containerElement) {
        containerElement.style.transitionDuration = time + 'ms';
      }
    }
    /**
     * Returns transition time.
     *
     * @returns {number} Transition time.
     */

  }, {
    key: "getTransitionDuration",
    value: function getTransitionDuration() {
      return this._transitionDuration;
    }
    /**
     * Enables transition for the set transition duration.
     *
     * @param {Function} [callback] Callback.
     * @param {number} [transitionDuration] Transition time.
     */

  }, {
    key: "transition",
    value: function transition() {
      var _this = this;

      var callback = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var transitionDuration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var transition = {
        callback: callback,
        timeout: 0,
        transitionDuration: transitionDuration || this.defaultTransitionTime
      };

      this._transitions.push(transition);

      this.setTransitionDuration(transition.transitionDuration);
      transition.timeout = setTimeout(function () {
        var index = _this._transitions.indexOf(transition);

        if (index !== -1) {
          _this._transitions.splice(index, 1);
        }

        if (_this._transitions.length === 0) {
          _this.setTransitionDuration(0);
        }

        if (transition.callback) {
          transition.callback({
            canceled: false
          });
        }
      }, transition.transitionDuration);
    }
    /**
     * Cancels a transitions.
     */

  }, {
    key: "cancelTransitions",
    value: function cancelTransitions() {
      this.setTransitionDuration(0);

      var _iterator = _createForOfIteratorHelper(this._transitions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var transition = _step.value;
          clearTimeout(transition.timeout);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this._transitions = [];
    }
    /**
     * Sets easing.
     *
     * @param {string} easing Easing.
     */

  }, {
    key: "setEasing",
    value: function setEasing(easing) {
      this._easing = easing;
    }
    /**
     * Returns easing.
     *
     * @returns {string} Easing.
     */

  }, {
    key: "getEasing",
    value: function getEasing() {
      return this._easing;
    }
    /**
     * Returns the wrapper element.
     *
     * @returns {Element} Wrapper element.
     */

  }, {
    key: "getWrapperElement",
    value: function getWrapperElement() {
      this._wrapperElement = this._wrapperElement || this._element.querySelector('.Swiper__wrapper');
      return this._wrapperElement;
    }
    /**
     * Returns the container element.
     *
     * @returns {Element} Container element.
     */

  }, {
    key: "_getContainerElement",
    value: function _getContainerElement() {
      this._containerElement = this._containerElement || this._element.querySelector('.Swiper__container');
      return this._containerElement;
    }
  }]);

  return SwiperAnimation;
}();

exports.default = SwiperAnimation;